import React, { useEffect } from 'react';
import { Hazard } from '../../hazards/Hazard.interface';
import { getProductEntityName } from '../Product.config';
import { useAssignUserNeedHazard } from '../Product.hooks';

import { BaseProductAssignDialogProps } from '../Product.interface';
import AssignHazardDialog from './AssignHazardDialog';

export type UserNeedAssignHazardDialogProps =
  BaseProductAssignDialogProps<'userNeedId'>;

const UserNeedAssignHazardDialog: React.FC<UserNeedAssignHazardDialogProps> = (
  props: UserNeedAssignHazardDialogProps
) => {
  const {
    open,
    productId,
    userNeedId,
    selectedItems,
    onCancel,
    onError,
    onAssigned
  } = props;
  const {
    updatedProductUserNeed,
    isAssigning,
    error: assignError,
    assignHazards
  } = useAssignUserNeedHazard(productId, userNeedId);

  useEffect(() => {
    if (updatedProductUserNeed) {
      onAssigned?.(updatedProductUserNeed);
    }
  }, [updatedProductUserNeed]);

  useEffect(() => {
    if (assignError) {
      onError?.(assignError);
    }
  }, [assignError]);

  return (
    <AssignHazardDialog
      {...{ open, productId, selectedItems, onCancel, onError }}
      isLoading={isAssigning}
      contentText={`Search for Hazards to assign to the ${getProductEntityName(
        'userNeed'
      )}.`}
      onSubmit={(hazards: Hazard[]) => {
        assignHazards({
          hazardIds: hazards.map((hazard: Hazard) => hazard.id)
        });
      }}
    />
  );
};

export default UserNeedAssignHazardDialog;
